import { render, staticRenderFns } from "./NewTemplateModelGroup.vue?vue&type=template&id=3b111353&scoped=true&"
import script from "./NewTemplateModelGroup.vue?vue&type=script&lang=js&"
export * from "./NewTemplateModelGroup.vue?vue&type=script&lang=js&"
import style0 from "./NewTemplateModelGroup.vue?vue&type=style&index=0&id=3b111353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b111353",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDataTable,VDialog,VIcon,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b111353')) {
      api.createRecord('3b111353', component.options)
    } else {
      api.reload('3b111353', component.options)
    }
    module.hot.accept("./NewTemplateModelGroup.vue?vue&type=template&id=3b111353&scoped=true&", function () {
      api.rerender('3b111353', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Template/modal/NewTemplateModelGroup.vue"
export default component.exports